import React from 'react'
import ProjectDetailsContent11 from '../TSALaw/ProjectDetailsContent11'
import RelatedProject11 from '../TSALaw/RelatedProject11'
import SidebarWidget11 from '../TSALaw/SidebarWidget11'

function ProjectDetailsWrap11() {
  return (
    <div>
      <div className="project-details sec-mar-top">

        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <ProjectDetailsContent11 />
            </div>
            <div className="col-lg-4">
              <SidebarWidget11 />
            </div>
            <RelatedProject11 />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectDetailsWrap11